// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5308":"4b4fe605d18f39f6","20020":"3c1a3338143cf37e","81048":"1b1cfdca7ca9df96"}[chunkId] + ".css";
};